import { RequirementDisplay } from '../../../../../../shared/frontend/scripts/recruitment/utils';
import { RAID_METADATA_BY_SLUG } from '../../../../shared/enums';

export const { getRequirementHighlights, buildDisplay, isRequirementComplete } = new RequirementDisplay(
  RAID_METADATA_BY_SLUG
);
